import React from 'react';
import { Col } from 'reactstrap';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { Fade } from 'react-awesome-reveal';

export const SmartlinksMusicMarketingBox: React.FC<{ icon: FontAwesomeIconProps['icon'] }> = ({ icon, children }) => {
  return (
    <Col xs={12} md={4} className="py-3">
      <Fade direction="up" triggerOnce className="h-100">
        <div className="smartlinks-music-marketing-box">
          <FontAwesomeIcon icon={icon} size="2x" />
          <div>
            <span>{children}</span>
          </div>
        </div>
      </Fade>
    </Col>
  );
};
